import Home from './Home';
import About from './About';
import Products from './Products';
import Gallery from './Gallery';
import Partners from './Partners';
import Help from './Help';
import Contact from './Contact';

// The public site as one scrolling page (on request) - each former
// standalone route is now a <section id="..."> here, in the same order
// Header's NAV_LINKS lists them, so the scrollspy and anchor links line up.
export default function OnePage() {
  return (
    <div>
      <Home />
      <About />
      <Products />
      <Gallery />
      <Partners />
      <Help />
      <Contact />
    </div>
  );
}
